import { clearCookies, clearStorage } from '../../../shared/misc';
import {
  LOGIN_USER,
  LOGOUT_USER,
} from '../constants';

export const loginUser = (user) => ({ type: LOGIN_USER, payload: user });

export const logoutUser = () => {
  clearCookies();
  clearStorage();
  return { type: LOGOUT_USER, payload: undefined };
};
